import type { MidiInfoObject, MidiMessage } from './soundBufferHolder';
// noteHolder
// note
// voice
// music

export default abstract class MusicObject {
  tempo?: number;

  abstract getMidiMessages(midiInfo?: MidiInfoObject): MidiMessage[];
}
